import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'help-menu',
    imports: [MatButtonModule, MatIconModule, MatMenuModule, MatDividerModule, MatTooltipModule],
    templateUrl: './help-menu.component.html',
})
export class HelpMenuComponent {
    protected readonly helpUrl = environment.helpUrl;

    protected openWebsite(url: string) {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
}
